import React from "react";
import List from "@mui/material/List";

import MoreOptionsButton from "modules/common/components/buttons/moreOptionsButton";
import MoreOptionsItem from "modules/common/components/moreOptionsItem";

interface IMoreOptionsSMSProps {
    onDownloadSMSActivityLog: () => void;
    onDownloadSubscriptionStatus: () => void;
    onDownloadSMSOutbox: () => void;
}

const MoreOptionsSMS: React.FC<IMoreOptionsSMSProps> = ({
    onDownloadSMSActivityLog,
    onDownloadSubscriptionStatus,
    onDownloadSMSOutbox,
}) => {
    return <MoreOptionsButton>
        <List disablePadding>
            <MoreOptionsItem
                text="Download SMS activity log"
                onClick={onDownloadSMSActivityLog}
            />
            <MoreOptionsItem
                text="Download subscription status report"
                onClick={onDownloadSubscriptionStatus}
            />
            <MoreOptionsItem
                text="Download SMS outbox"
                onClick={onDownloadSMSOutbox}
            />
        </List>
    </MoreOptionsButton>;
};

export default MoreOptionsSMS;
